import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Command, CommandItem, CommandList } from '@/components/ui/command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import {
  ARBEITNEHMER_TYP,
  ArbeitnehmerTyp,
} from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitnehmerTyp';
import { faCheck, faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function ArbeitnehmerTypFilter({
  selectedArbeitnehmerTypes,
  handleSelectArbeitnehmerTyp,
}: {
  selectedArbeitnehmerTypes: ArbeitnehmerTyp[];
  handleSelectArbeitnehmerTyp: (value: ArbeitnehmerTyp) => void;
}) {
  const { t } = useTranslation();

  return (
    <Popover modal>
      <PopoverTrigger asChild>
        <Button variant="ghost" className="me-2 flex items-center gap-1">
          <FontAwesomeIcon icon={faFilter} />
          <Badge variant="secondary" type="pill">
            {selectedArbeitnehmerTypes.length}
          </Badge>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-50 bg-white p-0">
        <Command>
          <CommandList>
            {ARBEITNEHMER_TYP.map((value) => (
              <CommandItem
                key={value}
                className="font-normal p-4 hover:cursor-pointer"
                onSelect={() => handleSelectArbeitnehmerTyp(value)}>
                <div className="flex items-center justify-between w-full">
                  {t(
                    `domain.mitarbeiter.rotationsplan.arbeitnehmerTyp.${value}`,
                  )}
                  {selectedArbeitnehmerTypes.includes(value) && (
                    <FontAwesomeIcon
                      className="text-primary-blue-600"
                      icon={faCheck}
                    />
                  )}
                </div>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
